module.exports = __webpack_public_path__ + "img/HN.6b22b859.png";